import React, { useEffect } from 'react';
import styled from 'styled-components';
import { TextXL } from '@atoms'
import { theme } from '@theme'
import {Link} from 'react-scroll'

export const TableOfContents = ({ tableOfContentsHeadings, ...props }) => {
  const scrollToHeading = (headingText) => {

  }

  return (
    <CompWrapper
      data-comp={TableOfContents.displayName}
      {...props}
    >
      <TextXL pb={3} style={{ fontWeight: 'bold' }}>Table of Contents</TextXL>
      <div className='toc-heading-links'>
        { tableOfContentsHeadings.map(heading => {
          if (heading?.nodeType === 'heading-2') {
            return (
              // Note: the reason we are hardcoding in the word false for the to prop is because for some reason the browser tacks on this word to the html ids that we set inside the blog detail template for the heading 2 block and the heading 3 block. We set these ids so that we had something unique to scroll to when user clicks one of the lines in the table of contents.
              <Link to={`false,${heading?.content[0]?.value}`} offset={-120}><TOCHeadingTwo onClick={scrollToHeading(heading?.content[0]?.value)} style={{ fontFamily: theme.font.primary }}>{heading?.content[0]?.value}</TOCHeadingTwo></Link>
            )
          } else {
            return (
              <Link to={`false,${heading?.content[0]?.value}`} offset={-120}><TOCHeadingThree onClick={scrollToHeading(heading?.content[0]?.value)} style={{ fontFamily: theme.font.primary }}>{heading?.content[0]?.value}</TOCHeadingThree></Link>
            )
          }
        })}
      </div>
    </CompWrapper>
  );
};

TableOfContents.displayName = 'TableOfContents';

const CompWrapper = styled.div`
  width: 100%;
  padding: 24px;
  border: 1px solid #E4E9F1;
  border-radius: 9px;
`

const TOCHeadingTwo = styled.div`
  margin: 4px 0px;
  cursor: pointer;
  padding: 0px 24px;
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  color: #1B1B1B;
  font-size: 16px;
  font-weight: 700;
  border-radius: 40px;
  &:hover {
    background: #E4E9F1;
    color: #5260FF;
  }
  @media (max-width: 600px) {
    padding: 0px 16px;
  }
`

const TOCHeadingThree = styled.div`
  margin: 4px 0px;
  cursor: pointer;
  padding: 0px 32px;
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  color: #1B1B1B;
  font-size: 16px;
  font-weight: 400;
  border-radius: 40px;
  &:hover {
    background: #E4E9F1;
    color: #5260FF;
  }
  @media (max-width: 600px) {
    padding: 0px 24px;
  }
`